import React from 'react';
import axios from '~/data/http/axios';
import Button from '~/Common-Objects/UI/Forms/Button/Button';
import Column from '~/Common-Objects/Grids/Column/Column';
import Icons from '~/Common-Objects/UI/Icons/index';
import Paper from '~/Common-Objects/UI/Paper/Paper';
import Row from '~/Common-Objects/Grids/Row/Row';

export default class RequiresSiteTracking extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return <Row>
            <Column xs={12} sm={8} className="col-sm-offset-2">
                <Paper>
                    <Row>
                        <Column xs={12} sm={6}>
                            <h4 className="mar-b25">Discover more about your Campaign Performance</h4>
                            <div className="text-heavy mar-b25">Events enable you to track when customers go on to Register or Pay for your service or products.</div>
                            <div className="mar-b25">You can then see exactly how successful your campaigns have been at converting subscribers into customers.</div>
                            <div className="mar-b25">Enabling events is easy, but does require the Site Tracking feature to be setup.</div>
                            <div className="quickFlex" style={{ alignItems: "center" }}>
                                <Button className="mar-r10 mar-b0" text="Get Started" iconRight={<Icons icon="arrowRight" />} onClick={() => { this.props.history.push('/cp/trackers') }} />
                                <Button className="mar-b0" text="Find out more about Events" iconLeft={<Icons icon="questionCircle" />} onClick={() => { this.props.history.push('/cp/trackers/events') }} />
                            </div>
                        </Column>
                        <Column xs={12} sm={6}>
                            <img
                                src="https://cdn1.ourmailsender.com/siteContent/siteTracking/siteTrackingScreenshot.png"
                                style={{ width: "100%", border: "1px solid #CCCCCC", borderRadius: "10px", overflow: "hidden" }} />
                        </Column>
                    </Row>
                </Paper >
            </Column >
        </Row >
    }
}